(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-collection-filter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-collection-filter-form')) {
    customElements.define('rc-collection-filter-form', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.dataset.enhanced = 'true';
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-rc-collection-sort]')) return;
          const form = event.target.form;
          if (!form.checkValidity()) {
            const filters = this.querySelector('details');
            if (filters) filters.open = true;
          }
          form.requestSubmit();
        });
        const fallback = this.querySelector('[data-rc-sort-submit]');
        if (fallback) fallback.hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
